import CheckBox from 'components/CheckBox'
import RadioButton from 'components/RadioButton'
import { Node } from 'data/types'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils'

import ExtraQuestions from './ExtraQuestions'

const Wrapper = styled.div`
  padding: 1.25rem 1.5rem;
  border-radius: 8px;
  display: grid;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${color('dark700')};
  cursor: pointer;
  grid-template-columns: 1fr min-content;
  gap: 1rem;
  background: ${color('dark900')};
`

const Label = styled.label`
  color: ${color('white')} !important;
  font-weight: bold;
  margin: 0;
  cursor: pointer;
`

const Description = styled.div`
  color: ${color('white')} !important;
  margin: 0;
  cursor: pointer;
`

type SingleSelectionProps = {
  checked: boolean
  description?: string
  label: string
  onChange: (option: Node) => void
  option: Node
  singleSelection?: boolean
}

const SingleInput = ({
  checked,
  description,
  label,
  onChange,
  option,
  singleSelection
}: SingleSelectionProps) => {
  if (option.type !== 'SELECTION') return null
  return (
    <Wrapper onClick={() => onChange({ ...option, checked: !option.checked })}>
      <div>
        <Label>{label}</Label>
        {description && <Description>{description}</Description>}
      </div>
      {singleSelection ? <RadioButton checked={checked} /> : <CheckBox checked={checked} />}
      {option.checked && <ExtraQuestions node={option} onChange={onChange} />}
    </Wrapper>
  )
}

export default SingleInput
